module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "no-wrap",
    attrs: {
      "md": 2,
      "lg": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.addDialog = true
      }
    }
  }, [_vm._v("新建签到活动")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "prop": "id",
      "label": "序号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "活动名称",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start_time",
      "label": "开始时间",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "end_time",
      "label": "结束时间",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.detailDialogShow(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editDialogShow(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.searchParams.pagesize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.searchParams.page,
      "total": _vm.total_count,
      "page-size": _vm.searchParams.pagesize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.searchParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.searchParams, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建签到活动",
      "width": "80%",
      "visible": _vm.addDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.addData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.addData.name),
      callback: function($$v) {
        _vm.$set(_vm.addData, "name", $$v)
      },
      expression: "addData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "2"
    },
    model: {
      value: (_vm.addData.status),
      callback: function($$v) {
        _vm.$set(_vm.addData, "status", $$v)
      },
      expression: "addData.status"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addData.act_type === 'd'),
      expression: "addData.act_type==='d'"
    }],
    attrs: {
      "label": "每日签到积分"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    on: {
      "input": _vm.handleInt
    },
    model: {
      value: (_vm.addData.points_num),
      callback: function($$v) {
        _vm.$set(_vm.addData, "points_num", $$v)
      },
      expression: "addData.points_num"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addData.act_type === 'd'),
      expression: "addData.act_type==='d'"
    }],
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "每日签到图片："
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('daily_sign_img')
      }
    }
  }, [(_vm.addData.daily_sign_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.addData.daily_sign_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n          注：图片|只能上传jpg/png文件，尺寸建议为1170*2260，单位为px，且不超过500KB\n        ")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addData.act_type === 'd'),
      expression: "addData.act_type==='d'"
    }],
    attrs: {
      "label": "连续签到奖励"
    }
  }), _vm._v(" "), _vm._l((_vm.addData.award), function(item, index) {
    return _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.addData.act_type === 'd'),
        expression: "addData.act_type==='d'"
      }],
      key: item.key
    }, [_c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("类型：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择",
        "size": "small"
      },
      model: {
        value: (item.award_type),
        callback: function($$v) {
          _vm.$set(item, "award_type", $$v)
        },
        expression: "item.award_type"
      }
    }, _vm._l((_vm.awardOptions), function(opt) {
      return _c('el-option', {
        key: opt.value,
        attrs: {
          "label": opt.label,
          "value": opt.value
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("连续天数：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (item.period_num),
        callback: function($$v) {
          _vm.$set(item, "period_num", $$v)
        },
        expression: "item.period_num"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("奖励积分：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (item.award_content),
        callback: function($$v) {
          _vm.$set(item, "award_content", $$v)
        },
        expression: "item.award_content"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("展示图片：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticClass: "upload-box",
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('continuous_sign_img', index)
        }
      }
    }, [(item.image) ? _c('img', {
      staticClass: "avatar",
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.image
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon",
      staticStyle: {
        "font-size": "20px"
      }
    })])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("描述：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": "请输入奖品描述"
      },
      model: {
        value: (item.award_description),
        callback: function($$v) {
          _vm.$set(item, "award_description", $$v)
        },
        expression: "item.award_description"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeAward(item)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addData.act_type === 'd'),
      expression: "addData.act_type==='d'"
    }],
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.addPeriod
    }
  }, [_vm._v("新增连续签到奖励")])], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newActivity
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑签到活动",
      "width": "80%",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editData.name),
      callback: function($$v) {
        _vm.$set(_vm.editData, "name", $$v)
      },
      expression: "editData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "2"
    },
    model: {
      value: (_vm.editData.status),
      callback: function($$v) {
        _vm.$set(_vm.editData, "status", $$v)
      },
      expression: "editData.status"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editData.act_type === 'd'),
      expression: "editData.act_type==='d'"
    }],
    attrs: {
      "label": "签到奖励积分数"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    on: {
      "input": _vm.handleInt
    },
    model: {
      value: (_vm.editData.points_num),
      callback: function($$v) {
        _vm.$set(_vm.editData, "points_num", $$v)
      },
      expression: "editData.points_num"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editData.act_type === 'd'),
      expression: "editData.act_type==='d'"
    }],
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "每日签到图片："
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('daily_sign_img')
      }
    }
  }, [(_vm.editData.daily_sign_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.editData.daily_sign_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n          注：图片|只能上传jpg/png文件，尺寸建议为1170*2260，单位为px，且不超过500KB\n        ")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editData.act_type === 'd'),
      expression: "editData.act_type==='d'"
    }],
    attrs: {
      "label": "连续签到奖励"
    }
  }), _vm._v(" "), _vm._l((_vm.editData.award), function(item, index) {
    return _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editData.act_type === 'd'),
        expression: "editData.act_type==='d'"
      }],
      key: item.key
    }, [_c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("类型：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择",
        "size": "small"
      },
      model: {
        value: (item.award_type),
        callback: function($$v) {
          _vm.$set(item, "award_type", $$v)
        },
        expression: "item.award_type"
      }
    }, _vm._l((_vm.awardOptions), function(opt) {
      return _c('el-option', {
        key: opt.value,
        attrs: {
          "label": opt.label,
          "value": opt.value
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("连续天数：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (item.period_num),
        callback: function($$v) {
          _vm.$set(item, "period_num", $$v)
        },
        expression: "item.period_num"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("奖励积分：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (item.award_content),
        callback: function($$v) {
          _vm.$set(item, "award_content", $$v)
        },
        expression: "item.award_content"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("展示图片：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticClass: "upload-box",
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('continuous_sign_img', index)
        }
      }
    }, [(item.image) ? _c('img', {
      staticClass: "avatar",
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.image
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon",
      staticStyle: {
        "font-size": "20px"
      }
    })])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("描述：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": "请输入奖品描述"
      },
      model: {
        value: (item.award_description),
        callback: function($$v) {
          _vm.$set(item, "award_description", $$v)
        },
        expression: "item.award_description"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeEditAward(item)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editData.act_type === 'd'),
      expression: "editData.act_type==='d'"
    }],
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.addEditPeriod
    }
  }, [_vm._v("新增连续签到奖励")])], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editActivity
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看签到活动",
      "width": "80%",
      "visible": _vm.viewDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.viewDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.detailData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.detailData.name),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "name", $$v)
      },
      expression: "detailData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "2",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.detailData.status),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "status", $$v)
      },
      expression: "detailData.status"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailData.act_type === 'd'),
      expression: "detailData.act_type==='d'"
    }],
    attrs: {
      "label": "签到奖励积分数"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "disabled"
    },
    on: {
      "input": _vm.handleInt
    },
    model: {
      value: (_vm.detailData.points_num),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "points_num", $$v)
      },
      expression: "detailData.points_num"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailData.act_type === 'd'),
      expression: "detailData.act_type==='d'"
    }],
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "每日签到图片："
    }
  }, [_c('div', {
    staticClass: "upload-box"
  }, [(_vm.detailData.daily_sign_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.detailData.daily_sign_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailData.act_type === 'd'),
      expression: "detailData.act_type==='d'"
    }],
    attrs: {
      "label": "连续签到奖励"
    }
  }), _vm._v(" "), _vm._l((_vm.detailData.award), function(item, index) {
    return _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.detailData.act_type === 'd'),
        expression: "detailData.act_type==='d'"
      }],
      key: item.key
    }, [_c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("类型：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择",
        "disabled": "disabled",
        "size": "small"
      },
      model: {
        value: (item.award_type),
        callback: function($$v) {
          _vm.$set(item, "award_type", $$v)
        },
        expression: "item.award_type"
      }
    }, _vm._l((_vm.awardOptions), function(opt) {
      return _c('el-option', {
        key: opt.value,
        attrs: {
          "label": opt.label,
          "value": opt.value
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("连续天数：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": "disabled",
        "size": "small"
      },
      model: {
        value: (item.period_num),
        callback: function($$v) {
          _vm.$set(item, "period_num", $$v)
        },
        expression: "item.period_num"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("奖励积分：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": "disabled",
        "size": "small"
      },
      model: {
        value: (item.award_content),
        callback: function($$v) {
          _vm.$set(item, "award_content", $$v)
        },
        expression: "item.award_content"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("展示图片：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [(item.image) ? _c('img', {
      staticClass: "avatar",
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.image
      }
    }) : _vm._e()]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("描述：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": "disabled",
        "size": "small"
      },
      model: {
        value: (item.award_description),
        callback: function($$v) {
          _vm.$set(item, "award_description", $$v)
        },
        expression: "item.award_description"
      }
    })], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewDialog = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-081219b5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-081219b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/membersSigninActivity/list.vue
// module id = 2446
// module chunks = 0